<template>
    <div>
        <button class="btn btn-outline-dark btn-sm mr-2 mb-1" data-toggle="modal" data-target="#newImportContactModal">Import Contact</button>
        
        <!-- Modal -->
        <div class="modal fade" id="newImportContactModal" ref="importModal" tabindex="-1" role="dialog" aria-labelledby="newImportContactModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="newImportContactModalLabel">Import Contact</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="importContact()">
                            <div class="form-group">
                                <label for="name" class="mb-1">
                                    <small>Accepted format - Excel(.xlsx)</small> <br>
                                    <small class="text-danger">The file should have the following headings: Name, Email, Phone</small>
                                </label>
                                <input type="file" class="mt-3" id="file" ref="file" v-on:change="handleFileUpload()">
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-dark btn-sm" data-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-custom-sm">Import Contact</button>
                            </div>
                            
                        </form>
                        
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            file: ''
        }
    },
    methods: {
        /*
        Handles a change on the file upload
        */
        handleFileUpload() {
            this.file = this.$refs.file.files[0];
        },
        async importContact() {

            const instance = axios.create({
                baseURL: 'https://api.moneypool.vesicash.com/v1',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem('access_token'),
                    'Content-Type': 'multipart/form-data'
                }
            });

            const headers = { 'Content-Type': 'multipart/form-data' };

            try {
                let formData = new FormData();

                formData.append('file', this.file);

                const imported = await instance.post('/pool/contacts/import', formData, { headers });

                if (imported.status == 200) {
                    $(this.$refs.importModal).modal('hide');

                    this.$emit('contact-uploaded');
                }                
            } catch (error) {
                console.log(error.response)
            }

        }
    }
}
</script>
<style >

</style>